module.exports = __webpack_public_path__ + "img/2.f5ca9120.png";